export interface User {
  id: string;
  email: string;
  firstName: string;
  lastName: string;
  isEmailVerified: boolean;
  createdAt: Date;
  updatedAt: Date;
  lastLoginAt?: Date;

  // Additional fields for onboarding (from story insights)
  onboardingCompleted?: boolean;
  onboardingStep?: number;
  language?: string;
}

/**
 * A person's display name: "First Last", trimmed, with a blank part dropped; `''` when both are.
 *
 * FAILURE IT PREVENTS: the web app and the admin app each hand-wrote this join inside their own
 * `useFullName` selector, and CodeQL's duplicate-logic gate caught the pair (#2274). Both now call
 * this, so one person cannot come to be named two ways as either copy drifts.
 */
export function formatFullName(person: Pick<User, 'firstName' | 'lastName'>): string {
  return [person.firstName, person.lastName].filter(Boolean).join(' ').trim();
}
